<template>
  <div class="featured-product-info">
    <img v-if="type === 'in_stock'" src="@/assets/icons/ui/in-stock_guarantee.png">
    <img v-else src="@/assets/icons/ui/new_style_icon.png">
  </div>
</template>

<script>
export default {
  name: 'FeaturedIcon',
  computed: {
  },
  props: {
    type: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
  #app {
    .featured-product-info {
      position: absolute;
      left: 10%;
      top: 0;
      width: 6em;
      max-height: 5em;
      display: flex;
      align-items: center;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
</style>